export default __webpack_public_path__ + "static/media/LOGO.db120199.svg";